import React, { useContext } from 'react';
import DeliveryOrderTable from 'app/edozvola/cases/delivery-order/delivery-order-table';
import { initialDeliveryOrder } from 'app/edozvola/cases/delivery-order/model/delivery-order.model';
import { deliveryOrderValidationSchema } from 'app/edozvola/cases/delivery-order/model/delivery-order.schema';
import { PredictiveInput } from 'edozvola-frontend-lib/dist/ui/components/predictive-input';
import { Alert, Col, Row } from 'reactstrap';
import { FormikProvider, useFormik } from 'formik';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import { CaseTabContext } from 'app/edozvola/cases/case-form-wrapper';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { initCaseFormChange, setFormChanged } from 'app/shared/reducers/case-form-change';
import {
  fetchDeliveryOrderQuery,
  saveDeliveryOrderQuery
} from 'app/edozvola/cases/delivery-order/service/delivery-order.queries';
import './delivery-order.scss'
import { fetchNoticeBoardDeliveryOptionsQuery, fetchPublicAuthorityOptionsQuery } from 'app/edozvola/codebooks/codebooks.queries';
import FormikValueObserver from 'app/shared/formik-observer/formik-observer';
import { Label } from 'edozvola-frontend-lib/dist/ui';
import {PaginatedDropdown} from "edozvola-frontend-lib/dist/ui/components/paginated-dropdown";
import { getCaseContext } from 'app/shared/util/context-util';

const DeliveryOrder = () => {

  const { id: uuid } = useParams<{ id: string }>();
  const { sidebarItemPair } = getCaseContext();
  const dispatch = useDispatch();

  const {data: noticeBoardDeliveryOptions, isLoading: noticeBoardDeliveryOptionsLoading} = fetchNoticeBoardDeliveryOptionsQuery();
  const {data: publicAuthorityOptions, isLoading: publicAuthorityOptionsLoading} = fetchPublicAuthorityOptionsQuery();

  const {data: deliveryOrder, isLoading: deliveryOrderLoading} = fetchDeliveryOrderQuery(uuid);

  const formik = useFormik({
    initialValues: deliveryOrder || initialDeliveryOrder,
    validationSchema: deliveryOrderValidationSchema,
    onSubmit: values => saveDeliveryOrder(values),
    enableReinitialize: true,
    validateOnMount: true,
  })

  const {mutate: saveDeliveryOrder, isPending: savingDeliveryOrder} = saveDeliveryOrderQuery(uuid, formik.resetForm);

  const addJPT = () => {
    formik.setFieldValue('publicAuthorities', [...formik.values.publicAuthorities, []])
  }

  const deleteAuthority = (indexToDelete: number) => {
    formik.setFieldValue(
      'publicAuthorities',
      formik.values.publicAuthorities
        .filter((authority, authorityIndex) => authorityIndex !== indexToDelete)
    );
  };

  return (
    <>
      <div className={'form-header'}>Dostavna naredba završnog akta</div>
      <div className={'mt-4'}>
        <DeliveryOrderTable />
      </div>
      <hr />
      <FormikProvider value={formik}>
        <FormikValueObserver
          onChange={dirty => {
            if (dirty.dirty) {
              dispatch(setFormChanged(true));
            } else {
              dispatch(initCaseFormChange());
            }
          }}
        />
        <div className={'form-header'}>Oglasna ploča</div>
        <Row className={'mt-4'}>
          <Col md={6}>
            <Label labelText={'Oglasna ploča'} />
            <PaginatedDropdown
              placeholder={!sidebarItemPair?.readOnly && 'Odaberi oglasnu ploču'}
              onItemSelect={selectedOption => formik.setFieldValue(`noticeBoardDelivery`, selectedOption)}
              selected={formik.values.noticeBoardDelivery}
              labelKey={'value'}
              options={noticeBoardDeliveryOptionsLoading ? [] : noticeBoardDeliveryOptions}
              disabled={sidebarItemPair?.readOnly}
              clearButton
            />
          </Col>
        </Row>
        <hr />
        <div className={'form-header'}>Na znanje - dostaviti</div>
        {formik.values.publicAuthorities.length === 0 && (
          <Alert color="info" className="mt-4 uniform-width">
            {'Nema dodanih javnopravnih tijela.'}
          </Alert>
        )}
        {formik.values.publicAuthorities.length !== 0 &&
          formik.values.publicAuthorities.map((publicAuthority, index) => (
            <Row key={index} className={'mt-4'}>
              <Col md={6}>
                <Label labelText={'Naziv tijela'} />
                <PaginatedDropdown
                  onItemSelect={selectedOption => formik.setFieldValue(`publicAuthorities.${index}`, selectedOption)}
                  selected={formik.values.publicAuthorities[index]}
                  labelKey={'value'}
                  options={publicAuthorityOptionsLoading ? [] : publicAuthorityOptions}
                  disabled={sidebarItemPair?.readOnly}
                  error={
                    !sidebarItemPair?.readOnly && formik.errors.publicAuthorities && formik.errors.publicAuthorities[index]
                      ? (formik.errors.publicAuthorities[index] as string)
                      : ''
                  }
                />
              </Col>
              {!sidebarItemPair?.readOnly && (
                <Col md={2}>
                  <Button
                    className={'delete-authority'}
                    prependIcon={'trash'}
                    color={'secondary'}
                    size={'lg'}
                    onClick={() => deleteAuthority(index)}
                  />
                </Col>
              )}
            </Row>
          ))}
        {!sidebarItemPair?.readOnly && (
          <Row>
            <Col md={6} className={'mt-4'}>
              <Button
                label={'Dodaj javnopravno tijelo'}
                color={'secondary'}
                prependIcon={'plus'}
                size={'lg'}
                disabled={!!formik.errors.publicAuthorities}
                onClick={addJPT}
              />
            </Col>
          </Row>
        )}
      </FormikProvider>
      {!sidebarItemPair?.readOnly && (
        <div className={'case-save-button'}>
          <Button
            label={'Spremi'}
            size={'lg'}
            disabled={!formik.dirty || !formik.isValid}
            isLoading={savingDeliveryOrder}
            color={'info'}
            onClick={() => formik.handleSubmit()}
          />
        </div>
      )}
    </>
  );
}

export default DeliveryOrder;
